import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ColoredEmptyImg = function ColoredEmptyImg(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/_jsxs("svg", {
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("circle", {
        id: _id,
        cx: "75",
        cy: "75",
        r: "75"
      })
    }), /*#__PURE__*/_jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-744, -319)",
        children: /*#__PURE__*/_jsxs("g", {
          transform: "translate(744, 319)",
          children: [/*#__PURE__*/_jsx("rect", {
            x: "0",
            y: "0",
            width: "160",
            height: "160"
          }), /*#__PURE__*/_jsxs("g", {
            transform: "translate(10, 10)",
            children: [/*#__PURE__*/_jsx("circle", {
              fill: "#0181FD",
              fillRule: "nonzero",
              cx: "75",
              cy: "75",
              r: "75"
            }), /*#__PURE__*/_jsxs("g", {
              transform: "translate(0, 0)",
              children: [/*#__PURE__*/_jsx("mask", {
                id: _id2,
                fill: "white",
                children: /*#__PURE__*/_jsx("use", {
                  xlinkHref: "#".concat(_id)
                })
              }), /*#__PURE__*/_jsx("g", {}), /*#__PURE__*/_jsx("ellipse", {
                fill: "#349AFD",
                fillRule: "nonzero",
                mask: "url(#".concat(_id2, ")"),
                cx: "75",
                cy: "158.659491",
                rx: "133.855186",
                ry: "57.0939335"
              })]
            }), /*#__PURE__*/_jsxs("g", {
              transform: "translate(18.6399, 19.9609)",
              children: [/*#__PURE__*/_jsx("path", {
                d: "M106.702544,86.5949119 L47.8473581,110.225049 C45.7925636,111.105675 43.444227,111.105675 41.3894325,110.225049 L0.440313112,93.7866928 C-0.146771037,93.4931507 -0.146771037,92.6125245 0.440313112,92.3189824 L59.295499,68.6888454 C61.3502935,67.8082192 63.6986301,67.8082192 65.7534247,68.6888454 L106.702544,85.1272016 C107.289628,85.4207436 107.289628,86.3013699 106.702544,86.5949119 Z",
                fill: "#132039"
              }), /*#__PURE__*/_jsxs("g", {
                transform: "translate(46.6732, 37.5734)",
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M0,43.8845401 L0,14.8238748 C0,13.0626223 1.02739726,11.4481409 2.78864971,10.7142857 L28.1800391,0.440313112 C29.6477495,-0.146771037 31.1154599,-0.146771037 32.5831703,0.440313112 L57.9745597,10.7142857 C59.5890411,11.4481409 60.7632094,13.0626223 60.7632094,14.8238748 L60.7632094,43.8845401 C60.7632094,45.6457926 59.7358121,47.260274 57.9745597,47.9941292 L32.5831703,58.1213307 C31.1154599,58.7084149 29.6477495,58.7084149 28.1800391,58.1213307 L2.78864971,47.9941292 C1.1741683,47.407045 0,45.7925636 0,43.8845401 Z",
                  fill: "#FFFFFF"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M2.05479452,13.3561644 L28.4735812,23.9236791 C29.6477495,24.3639922 30.3816047,25.5381605 30.3816047,26.7123288 L30.3816047,56.5068493 C30.3816047,57.2407045 29.6477495,57.6810176 29.0606654,57.3874755 L2.64187867,46.9667319 C1.46771037,46.5264188 0.733855186,45.3522505 0.733855186,44.1780822 L0.733855186,14.0900196 C0.733855186,13.6497065 1.46771037,13.0626223 2.05479452,13.3561644 Z",
                  fill: "#F2F2F2"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M31.1154599,0.733855186 L57.5342466,11.4481409 C57.9745597,11.5949119 57.9745597,12.1819961 57.5342466,12.3287671 L31.702544,22.7495108 C31.2622309,22.8962818 30.8219178,22.8962818 30.2348337,22.7495108 L3.22896282,12.3287671 C2.78864971,12.1819961 2.78864971,11.5949119 3.22896282,11.4481409 L29.6477495,0.880626223 C30.0880626,0.587084149 30.6751468,0.587084149 31.1154599,0.733855186 Z",
                  fill: "#132039"
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(24.9511, 2.7886)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(25.0978, 12.7691)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(9.6869, 7.7789)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.57729941",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(39.9217, 7.7789)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                })]
              }), /*#__PURE__*/_jsxs("g", {
                transform: "translate(47.407, 0)",
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M0,43.8845401 L0,14.8238748 C0,13.0626223 1.02739726,11.4481409 2.78864971,10.7142857 L28.1800391,0.440313112 C29.6477495,-0.146771037 31.1154599,-0.146771037 32.5831703,0.440313112 L57.9745597,10.7142857 C59.5890411,11.4481409 60.7632094,13.0626223 60.7632094,14.8238748 L60.7632094,43.8845401 C60.7632094,45.6457926 59.7358121,47.260274 57.9745597,47.9941292 L32.5831703,58.1213307 C31.1154599,58.7084149 29.6477495,58.7084149 28.1800391,58.1213307 L2.78864971,47.9941292 C1.02739726,47.407045 0,45.7925636 0,43.8845401 Z",
                  fill: "#07C846"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M1.90802348,13.3561644 L28.3268102,23.9236791 C29.5009785,24.3639922 30.2348337,25.5381605 30.2348337,26.7123288 L30.2348337,56.5068493 C30.2348337,57.2407045 29.5009785,57.6810176 28.9138943,57.3874755 L2.49510763,46.9667319 C1.32093933,46.5264188 0.587084149,45.3522505 0.587084149,44.1780822 L0.587084149,14.2367906 C0.587084149,13.6497065 1.32093933,13.0626223 1.90802348,13.3561644 Z",
                  fill: "#09AF38"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M31.1154599,0.733855186 L57.5342466,11.4481409 C57.9745597,11.5949119 57.9745597,12.1819961 57.5342466,12.3287671 L31.702544,22.7495108 C31.2622309,22.8962818 30.8219178,22.8962818 30.2348337,22.7495108 L3.08219178,12.3287671 C2.64187867,12.1819961 2.64187867,11.5949119 3.08219178,11.4481409 L29.5009785,0.880626223 C30.0880626,0.587084149 30.5283757,0.587084149 31.1154599,0.733855186 Z",
                  fill: "#51D87D"
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(24.9511, 2.7886)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(24.9511, 12.7691)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(9.6869, 7.7789)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(39.775, 7.7789)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                })]
              }), /*#__PURE__*/_jsxs("g", {
                transform: "translate(14.3836, 50.4892)",
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M0,43.8845401 L0,14.8238748 C0,13.0626223 1.02739726,11.4481409 2.78864971,10.7142857 L28.1800391,0.440313112 C29.6477495,-0.146771037 31.1154599,-0.146771037 32.5831703,0.440313112 L57.9745597,10.7142857 C59.5890411,11.4481409 60.7632094,13.0626223 60.7632094,14.8238748 L60.7632094,43.8845401 C60.7632094,45.6457926 59.7358121,47.260274 57.9745597,47.9941292 L32.5831703,58.1213307 C31.1154599,58.7084149 29.6477495,58.7084149 28.1800391,58.1213307 L2.78864971,47.9941292 C1.1741683,47.407045 0,45.7925636 0,43.8845401 Z",
                  fill: "#07C846"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M2.05479452,13.3561644 L28.4735812,23.9236791 C29.6477495,24.3639922 30.3816047,25.5381605 30.3816047,26.7123288 L30.3816047,56.6536204 C30.3816047,57.3874755 29.6477495,57.8277886 29.0606654,57.5342466 L2.64187867,47.1135029 C1.46771037,46.6731898 0.733855186,45.4990215 0.733855186,44.3248532 L0.733855186,14.2367906 C0.733855186,13.6497065 1.32093933,13.0626223 2.05479452,13.3561644 Z",
                  fill: "#09AF38"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M31.1154599,0.733855186 L57.5342466,11.4481409 C57.9745597,11.5949119 57.9745597,12.1819961 57.5342466,12.3287671 L31.702544,22.7495108 C31.2622309,22.8962818 30.8219178,22.8962818 30.2348337,22.7495108 L3.08219178,12.3287671 C2.64187867,12.1819961 2.64187867,11.5949119 3.08219178,11.4481409 L29.5009785,0.880626223 C30.0880626,0.587084149 30.6751468,0.587084149 31.1154599,0.733855186 Z",
                  fill: "#51D87D"
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(24.9511, 2.7886)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(25.0978, 12.7691)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(9.6869, 7.7789)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.57729941",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(39.9217, 7.7789)",
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M9.98043053,2.64187867 C8.95303327,1.90802348 7.33855186,1.46771037 5.43052838,1.46771037 C3.52250489,1.46771037 1.90802348,1.90802348 0.880626223,2.64187867 L0,2.64187867 L0,4.10958904 C0,5.57729941 2.49510763,6.75146771 5.43052838,6.75146771 C8.36594912,6.75146771 10.8610568,5.57729941 10.8610568,4.10958904 L10.8610568,2.64187867 L9.98043053,2.64187867 Z",
                    fill: "#09AF38"
                  }), /*#__PURE__*/_jsx("ellipse", {
                    fill: "#51D87D",
                    cx: "5.43052838",
                    cy: "2.64187867",
                    rx: "5.43052838",
                    ry: "2.64187867"
                  })]
                })]
              }), /*#__PURE__*/_jsxs("g", {
                transform: "translate(14.3836, 13.6497)",
                stroke: "#FFFFFF",
                strokeLinecap: "round",
                strokeWidth: "1.06100796",
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M0,43.8845401 L0,14.8238748 C0,13.0626223 1.02739726,11.4481409 2.78864971,10.7142857 L28.1800391,0.440313112 C29.6477495,-0.146771037 31.1154599,-0.146771037 32.5831703,0.440313112 L57.9745597,10.7142857 C59.5890411,11.4481409 60.7632094,13.0626223 60.7632094,14.8238748 L60.7632094,43.8845401 C60.7632094,45.6457926 59.7358121,47.260274 57.9745597,47.9941292 L32.5831703,58.1213307 C31.1154599,58.7084149 29.6477495,58.7084149 28.1800391,58.1213307 L2.78864971,47.9941292 C1.1741683,47.260274 0,45.6457926 0,43.8845401 Z",
                  strokeDasharray: "2.800353747569389,2.800353747569389"
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(3.1556, 13.2094)",
                  children: [/*#__PURE__*/_jsx("line", {
                    x1: "0.0733855186",
                    y1: "0.733855186",
                    x2: "1.39432485",
                    y2: "1.32093933"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M4.18297456,2.49510763 L24.8776908,10.8610568 C26.3454012,11.4481409 28.1066536,11.4481409 29.574364,10.8610568 L52.0303327,1.61448141",
                    strokeDasharray: "2.833174310038305,2.833174310038305"
                  }), /*#__PURE__*/_jsx("line", {
                    x1: "53.351272",
                    y1: "1.02739726",
                    x2: "54.6722114",
                    y2: "0.440313112"
                  })]
                }), /*#__PURE__*/_jsxs("g", {
                  transform: "translate(29.7945, 27.1526)",
                  children: [/*#__PURE__*/_jsx("line", {
                    x1: "0.733855186",
                    y1: "28.6203523",
                    x2: "0.733855186",
                    y2: "27.1526419"
                  }), /*#__PURE__*/_jsx("line", {
                    x1: "0.733855186",
                    y1: "24.3639922",
                    x2: "0.733855186",
                    y2: "2.93542074",
                    strokeDasharray: "2.748859381907606,2.748859381907606"
                  }), /*#__PURE__*/_jsx("line", {
                    x1: "0.733855186",
                    y1: "1.46771037",
                    x2: "0.733855186",
                    y2: "0"
                  })]
                })]
              }), /*#__PURE__*/_jsx("path", {
                d: "M80.4305284,25.5381605 C78.5225049,24.5107632 76.7612524,22.1624266 76.0273973,19.5205479 C76.0273973,19.2270059 75.7338552,19.0802348 75.5870841,19.0802348 C75.2935421,19.0802348 75.146771,19.2270059 75.146771,19.5205479 C74.4129159,22.1624266 72.6516634,24.5107632 70.7436399,25.5381605 C70.5968689,25.6849315 70.4500978,25.8317025 70.4500978,25.9784736 C70.4500978,26.1252446 70.5968689,26.4187867 70.7436399,26.4187867 C72.6516634,27.446184 74.4129159,29.7945205 75.146771,32.4363992 C75.146771,32.7299413 75.4403131,32.8767123 75.5870841,32.8767123 C75.8806262,32.8767123 76.0273973,32.7299413 76.0273973,32.4363992 C76.7612524,29.7945205 78.5225049,27.446184 80.4305284,26.4187867 C80.5772994,26.2720157 80.7240705,26.1252446 80.7240705,25.9784736 C80.7240705,25.8317025 80.5772994,25.5381605 80.4305284,25.5381605 Z",
                fill: "#FFA005",
                fillRule: "nonzero"
              }), /*#__PURE__*/_jsx("path", {
                d: "M86.1545988,40.0684932 C84.9804305,39.481409 83.9530333,38.0136986 83.3659491,36.3992172 C83.3659491,36.2524462 83.2191781,36.1056751 83.072407,36.1056751 C82.925636,36.1056751 82.778865,36.2524462 82.778865,36.3992172 C82.3385519,38.0136986 81.3111546,39.481409 79.9902153,40.0684932 C79.8434442,40.0684932 79.8434442,40.2152642 79.8434442,40.3620352 C79.8434442,40.5088063 79.8434442,40.6555773 79.9902153,40.6555773 C81.1643836,41.2426614 82.1917808,42.7103718 82.778865,44.3248532 C82.778865,44.4716243 82.925636,44.6183953 83.072407,44.6183953 C83.2191781,44.6183953 83.3659491,44.4716243 83.3659491,44.3248532 C83.8062622,42.7103718 84.8336595,41.2426614 86.1545988,40.6555773 C86.3013699,40.6555773 86.3013699,40.5088063 86.3013699,40.3620352 C86.3013699,40.2152642 86.3013699,40.2152642 86.1545988,40.0684932 Z",
                fill: "#FFA005",
                fillRule: "nonzero"
              })]
            })]
          }), /*#__PURE__*/_jsx("path", {
            d: "M47.9575597,97.0748614 C45.5526083,95.8022181 43.4305924,92.974122 42.4403183,89.7218115 C42.2988506,89.4390018 42.1573828,89.297597 41.8744474,89.297597 C41.5915119,89.297597 41.3085765,89.4390018 41.3085765,89.7218115 C40.3183024,92.974122 38.1962865,95.8022181 35.7913351,97.0748614 C35.6498674,97.2162662 35.5083996,97.357671 35.5083996,97.6404806 C35.5083996,97.9232902 35.6498674,98.064695 35.7913351,98.2060998 C38.1962865,99.4787431 40.3183024,102.306839 41.3085765,105.55915 C41.4500442,105.841959 41.5915119,105.983364 41.8744474,105.983364 C42.1573828,105.983364 42.4403183,105.841959 42.4403183,105.55915 C43.4305924,102.306839 45.5526083,99.4787431 47.9575597,98.2060998 C48.0990274,98.064695 48.2404951,97.9232902 48.2404951,97.6404806 C48.2404951,97.357671 48.0990274,97.2162662 47.9575597,97.0748614 Z",
            fill: "#FFA005",
            fillRule: "nonzero"
          }), /*#__PURE__*/_jsxs("g", {
            children: [/*#__PURE__*/_jsx("g", {
              fill: "#07C846",
              children: /*#__PURE__*/_jsx("circle", {
                cx: "26.5",
                cy: "26.5",
                r: "26.5"
              })
            }), /*#__PURE__*/_jsx("path", {
              d: "M40.0319149,23.2579787 L29.7420213,23.2579787 L29.7420213,12.9680851 C29.7420213,11.981383 28.8962766,10.9946809 27.768617,10.9946809 L25.0904255,10.9946809 C24.1037234,10.9946809 23.1170213,11.8404255 23.1170213,12.9680851 L23.1170213,23.2579787 L12.8271277,23.2579787 C11.8404255,23.2579787 10.8537234,24.1037234 10.8537234,25.231383 L10.8537234,27.9095745 C10.8537234,28.8962766 11.6994681,29.8829787 12.8271277,29.8829787 L23.1170213,29.8829787 L23.1170213,40.1728723 C23.1170213,41.1595745 23.962766,42.1462766 25.0904255,42.1462766 L27.768617,42.1462766 C28.7553191,42.1462766 29.7420213,41.3005319 29.7420213,40.1728723 L29.7420213,29.8829787 L40.0319149,29.8829787 C41.018617,29.8829787 42.0053191,29.037234 42.0053191,27.9095745 L42.0053191,25.231383 C42.0053191,24.1037234 41.1595745,23.2579787 40.0319149,23.2579787 Z",
              fill: "#FFFFFF",
              fillRule: "nonzero"
            })]
          })]
        })
      })
    })]
  });
};
if (process.env.NODE_ENV !== 'production') {
  ColoredEmptyImg.displayName = 'ColoredEmptyImg';
}
export default ColoredEmptyImg;